// Participant-facing task content resolver (descriptions + starters), from the
// verbatim canonical module. No solutions, graders, or keys here.
import * as C from './canonicalContent.generated'
import { warmupParticipantMd } from './screeningScreens'

// The A1/B1 instructions doc holds both tasks; split at "## Task 2:".
function splitA1B1 () {
  const md = C.A1B1_INSTRUCTIONS_MD
  const i = md.indexOf('## Task 2:')
  return i === -1 ? { a1: md, b1: md } : { a1: md.slice(0, i).trim(), b1: md.slice(i).trim() }
}
const AB = splitA1B1()

export const TASKS = {
  // Screening warm-up. The canonical doc carries the scoring rubric and the eligibility
  // gate alongside the participant text — only the participant-facing section is shown.
  warmup: {
    id: 'warmup',
    name: 'Warm-up — Event Log Summarizer',
    domain: 'screening',
    starter: C.WARMUP_STARTER,
    descriptionMd: warmupParticipantMd(C.WARMUP_TASK_MD)
  },
  a1: { id: 'a1', name: 'Task 1 — Concurrent Execution', domain: 'concurrency',    starter: C.A1_STARTER, descriptionMd: AB.a1 },
  b1: { id: 'b1', name: 'Task 2 — Error Handling in Async Code', domain: 'error_handling', starter: C.B1_STARTER, descriptionMd: AB.b1 },
  a2: { id: 'a2', name: 'System Startup Sequence', domain: 'concurrency',    starter: C.A2_STARTER, descriptionMd: C.A2_TASK_MD },
  b2: { id: 'b2', name: 'Resilient Record Retrieval', domain: 'error_handling', starter: C.B2_STARTER, descriptionMd: C.B2_TASK_MD }
}

export const taskContent = (id) => TASKS[id] || null
